import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { ActivityDeviationStatus, GeoLocation } from '@wilson/interfaces';
import { ShiftCardTooltipStateService } from './shift-card-tooltip-state.service';
import { CommonModule } from '@angular/common';
import {
  ShiftValidationsCoreModule,
  TimelineShiftValidationTooltipComponent,
} from '@wilson/shift-validations/core';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { TimeLineShiftTooltipComponent } from '../timeline-shift-tooltip/timeline-shift-tooltip.component';

@Component({
  selector: 'wilson-shift-card-tooltip',
  templateUrl: './shift-card-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ShiftValidationsCoreModule,
    TimeLineShiftTooltipComponent,
    NzSkeletonModule,
    TimelineShiftValidationTooltipComponent,
  ],
})
export class ShiftCardTooltipComponent {
  shiftCardTooltipStateService = inject(ShiftCardTooltipStateService);

  @Input() showShiftValidation = true;
  @Input() plannedShiftStartDateTime!: string;
  @Input() plannedShiftEndDateTime!: string;
  @Input() accurateShiftStartDateTime!: string;
  @Input() shiftStartTimeDifference!: number;
  @Input() accurateShiftEndDateTime!: string;
  @Input() shiftEndTimeDifference!: number;
  @Input() shiftStartTimeType!: ActivityDeviationStatus;
  @Input() shiftEndTimeType!: ActivityDeviationStatus;
  @Input() plannedStartLocation!:
    | Pick<GeoLocation, 'name' | 'locationCode'>
    | undefined
    | null;
  @Input() plannedEndLocation!:
    | Pick<GeoLocation, 'name' | 'locationCode'>
    | undefined
    | null;
  @Input() reportedStartLocation!:
    | Pick<GeoLocation, 'name' | 'locationCode'>
    | null
    | undefined;
  @Input() reportedEndLocation!:
    | Pick<GeoLocation, 'name' | 'locationCode'>
    | null
    | undefined;

  @Output() tooltipExpanded = new EventEmitter();
}
